'use client';

import type { FC } from 'react';
import { Pagination } from 'swiper/modules';
import type { SwiperProps } from 'swiper/react';
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import 'swiper/css/pagination';

import { cn } from '@/lib/utils';

export interface SwiperElementProps extends SwiperProps {
    sliderClassName?: string;
}

const SwiperElement: FC<SwiperElementProps> = ({
    className,
    children,
    sliderClassName,
    ...props
}) => (
    <Swiper
        className={cn('w-full', className)}
        modules={[Pagination]}
        {...props}
    >
        {Array.isArray(children) &&
            children.map((sliderContent, i) => (
                <SwiperSlide
                    key={'swiper-slide-' + i}
                    className={cn('max-w-fit', sliderClassName)}
                >
                    {sliderContent}
                </SwiperSlide>
            ))}
    </Swiper>
);

export default SwiperElement;
